/* ====================================================================
   FLOOREVER — REPLIS RESPONSIVES (<details data-pli="…">)
   Utilisé par : sections/floorever-comparatif.liquid (« Comparer les
   7 gammes ») et sections/floorever-collection.liquid (filtres rapides,
   repli « Plus de filtres » sous 640 px, data-pli="639" ; la coupe de
   l'accueil n'a plus de repli depuis le 16/10/2026). Vanilla JS, defer,
   aucune dépendance.

   Décision Christopher 15/10/2026 (objectif n° 1 de l'accueil =
   rétention) : le comparatif et la coupe sont repliés sur mobile pour
   raccourcir la page, dépliés au-delà du seuil (data-pli = largeur
   max en px du mode replié, défaut 767).

   Mécanique : le <details> est rendu FERMÉ (aucun flash sur mobile) ;
   au-delà du seuil le script l'ouvre et le CSS masque le <summary>.
   Sans JS : un <noscript> dans la section réaffiche le summary à
   toutes les largeurs, le repli reste cliquable. Un lien d'ancre vers
   un repli fermé (ex. « Comparer nos gammes » → #comparatif) l'ouvre.
   ==================================================================== */
(function () {
  'use strict';
  if (window.FloorEverPli) return; /* chargé par plusieurs sections : une seule instance */
  window.FloorEverPli = true;

  function initUn(d) {
    if (d.dataset.pliInit === '1') return;
    d.dataset.pliInit = '1';
    var max = parseInt(d.getAttribute('data-pli'), 10) || 767;
    var mq = window.matchMedia('(max-width: ' + max + 'px)');

    /* Au franchissement du seuil : ouvert au-delà, fermé en dessous. À
       l'initialisation on se contente d'OUVRIR au-delà du seuil : un repli
       déjà ouvert par un autre script (ex. floorever-collection.js qui
       restaure un filtre depuis le hash) reste ouvert sur mobile. */
    function appliquer(evenement) {
      if (evenement) d.open = !mq.matches;
      else if (!mq.matches) d.open = true;
    }

    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', appliquer);
    else if (typeof mq.addListener === 'function') mq.addListener(appliquer);
    appliquer();
  }

  function init(scope) {
    (scope || document).querySelectorAll('details[data-pli]').forEach(initUn);
  }

  /* Une ancre qui vise un repli fermé (ou un élément qu'il contient) l'ouvre. */
  function ouvrirCible() {
    var h = window.location.hash;
    if (!h || h.length < 2) return;
    var id;
    try { id = decodeURIComponent(h.slice(1)); } catch (e) { id = h.slice(1); }
    var el = document.getElementById(id);
    if (!el) return;
    var dedans = el.closest('details[data-pli]');
    var dessous = el.querySelector('details[data-pli]');
    [dedans, dessous].forEach(function (d) { if (d && !d.open) d.open = true; });
  }

  function demarrer() { init(); ouvrirCible(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
  window.addEventListener('hashchange', ouvrirCible);

  /* Rechargement de section dans l'éditeur de thème. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
}());
